import { RootState } from "@/redux/store"
import { useGetSafetyCheckUpdates } from "@/services"
import { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"

const useChecksNoteDialog = () => {
  const {id} = useParams();
  const { taskData, checksData } = useSelector((state: RootState) => state.currentData)
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState<any[]>([]);
  const {data: attachmentList, isLoading: isAttachmentsLoading} = useGetSafetyCheckUpdates({
    taskId: taskData?.taskId,
    projectId: id as string,
    checkId: checksData?.taskSafetyCheckId,
    queryParams: {
      enabled: !!checksData?.taskSafetyCheckId
    }
  })

  const title = useMemo(() => {
    return `${checksData?.name} - Notes` || ''
  }, [checksData])

  const handleOpenSlider = (data: any) => {
    const validAttachments = data?.attachments?.filter((a: any) => a.presignedUrl);
    if (!data.description || !validAttachments || validAttachments.length === 0) return;

    const photos = validAttachments.map((a: any) => ({
      url: a.presignedUrl,
      description: a.fileDescription || data.description || "No description provided",
    }));
    setSelectedPhotos(photos);
    setIsSliderOpen(true);
  };


  return {
    isAttachmentsLoading,
    attachmentList,
    title,
    isSliderOpen,
    setIsSliderOpen,
    selectedPhotos,
    handleOpenSlider
  }
}

export default useChecksNoteDialog;